import { FormErrorText } from '@exam-management/components';
import { Box, Flex, Grid, SectionTitle, Text } from '@shared/components';

import { useQConfigSettingsFormContext } from '../../providers';

import OverallScoreTable from './overall-score-table';
import PartScoreTable from './part-score-table';

interface PassingCriteriaSectionProps {
  disabled: boolean;
}

export default function PassingCriteriaSection(props: Readonly<PassingCriteriaSectionProps>) {
  const { disabled: isDisabled } = props;
  const formContext = useQConfigSettingsFormContext();
  const errorMessage = formContext.formState.errors.passingCriteria?.overall?.root?.message;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(8) }}>
      <SectionTitle title='Passing Criteria' />
      <Grid
        sx={(theme) => ({
          gridTemplate: '1fr / 240px 1fr',
          columnGap: theme.spacing(6),
        })}
      >
        <Box>
          <Text variant='body1Semibold'>เกณฑ์การผ่าน</Text>
        </Box>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
          <Box sx={{ width: '304px' }}>
            <OverallScoreTable disabled={isDisabled} />
            {errorMessage ? (
              <FormErrorText sx={{ mt: (theme) => theme.spacing(2) }}>{errorMessage}</FormErrorText>
            ) : null}
          </Box>
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
            <Text>กรุณากำหนดคะแนนรวมที่ต้องผ่าน เพื่อเปิดใช้งานการตั้งค่าคะแนนรายหมวด</Text>
            <PartScoreTable disabled={isDisabled} />
          </Flex>
        </Flex>
      </Grid>
    </Flex>
  );
}
